(function () {
  var TYPES = 'product,query,collection,page';
  var FIELDS = 'title,product_type,variants.title,variants.sku,vendor';

  function patchFetch() {
    var current = window.fetch;
    if (!current || current.__lsPatched) return;
    var wrapped = function (input, init) {
      try {
        var raw = typeof input === 'string' ? input : input && input.url;
        if (raw && raw.indexOf('/search/suggest') !== -1 && raw.indexOf('section_id=predictive-search') !== -1) {
          var url = new URL(raw, location.origin);
          if (!url.searchParams.has('resources[type]')) {
            url.searchParams.set('resources[type]', TYPES);
            url.searchParams.set('resources[options][fields]', FIELDS);
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            url.searchParams.set('resources[limit]', '4');
            input = typeof input === 'string' ? url.toString() : new Request(url.toString(), input);
          }
        }
      } catch (e) {}
      return current.call(this, input, init);
    };
    wrapped.__lsPatched = true;
    window.fetch = wrapped;
  }

  patchFetch();
  document.addEventListener('DOMContentLoaded', patchFetch);
  window.addEventListener('load', function () {
    patchFetch();
    setTimeout(patchFetch, 1500);
  });

  function px(n) {
    return Math.round(n) + 'px';
  }

  function anchor(dlg) {
    var btn = document.querySelector('#header-component .search-action--bar button');
    if (!btn || window.innerWidth < 750) {
      dlg.classList.remove('ls-anchored');
      return;
    }
    var r = btn.getBoundingClientRect();
    if (r.width < 40) {
      dlg.classList.remove('ls-anchored');
      return;
    }
    var w = Math.max(r.width, 560);
    var left = Math.max(16, Math.min(r.left, window.innerWidth - 16 - w));
    dlg.style.setProperty('--ls-sa-top', px(r.top));
    dlg.style.setProperty('--ls-sa-left', px(left));
    dlg.style.setProperty('--ls-sa-w', px(w));
    dlg.classList.add('ls-anchored');
  }

  function labels(dlg) {
    var inp = dlg.querySelector('.search-input');
    var btn = dlg.querySelector('.predictive-search__search-button');
    if (inp) inp.placeholder = 'Search product, SKU or old part number';
    if (inp && btn) {
      var q = inp.value.trim();
      btn.textContent = q ? 'Search for "' + q + '", view all results' : 'View all results';
    }
  }

  function money(n) {
    var s = n.toFixed(2);
    return '£' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function vatLines(dlg) {
    dlg.querySelectorAll('.predictive-search-results__card--product').forEach(function (card) {
      if (card.querySelector('.ls-ps-exc, .ls-ex')) return;
      var target = null;
      var cands = card.querySelectorAll('[class*="price"]');
      for (var i = cands.length - 1; i >= 0; i--) {
        if (/£\s?\d/.test(cands[i].textContent)) {
          target = cands[i];
          break;
        }
      }
      if (!target) return;
      var found = target.textContent.match(/£\s?[\d,]+(?:\.\d+)?/g);
      if (!found) return;
      var inc = null;
      found.forEach(function (t) {
        var v = parseFloat(t.replace(/[^0-9.]/g, ''));
        if (v && (inc === null || v < inc)) inc = v;
      });
      if (!inc) return;
      var line = document.createElement('span');
      line.className = 'ls-ps-exc';
      line.textContent = money(inc / 1.2) + ' ex VAT';
      target.parentNode.insertBefore(line, target.nextSibling);
    });
  }

  function init() {
    var host = document.getElementById('search-modal');
    var dlg = host && host.querySelector('dialog');
    if (!dlg) return;
    var refresh = function () {
      if (!dlg.hasAttribute('open')) return;
      patchFetch();
      anchor(dlg);
      labels(dlg);
      vatLines(dlg);
    };
    new MutationObserver(refresh).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    var results = dlg.querySelector('.predictive-search-form__content');
    if (results) {
      new MutationObserver(function () {
        labels(dlg);
        vatLines(dlg);
      }).observe(results, { childList: true, subtree: true });
    }
    dlg.addEventListener('input', function () {
      patchFetch();
      labels(dlg);
      setTimeout(function () { vatLines(dlg); }, 700);
      setTimeout(function () { vatLines(dlg); }, 1500);
    });
    dlg.addEventListener(
      'click',
      function (e) {
        var pill = e.target.closest ? e.target.closest('.predictive-search-results__card--query a') : null;
        if (!pill) return;
        e.preventDefault();
        e.stopPropagation();
        var inp = dlg.querySelector('.search-input');
        if (!inp) return;
        var term = pill.textContent.replace(/\s+/g, ' ').trim();
        var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        setter.call(inp, term);
        inp.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: term }));
        inp.focus();
        try {
          inp.setSelectionRange(term.length, term.length);
        } catch (err) {}
      },
      true
    );
    window.addEventListener('resize', function () {
      if (dlg.hasAttribute('open')) anchor(dlg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
